function generateConfig (env) {
  const baseUrl = env === 'prod' ? 'https://fujian.xinyonghome.com' : 'http://localhost:8050'

  return {
    env,
    baseUrl
  }
}
const envConfig = {
  // env: 'test'
  env: 'prod'
}
export default generateConfig(envConfig.env)
